/* ============================================================================
FILE: po-doc-posoennoisme-runtime-fr-en-es-20260203.js
MODE: inject full HTML (FR/EN/ES) from JSON asset into slots
ROOT: .po-docwrap[data-po-posoennoisme]
API:  window.PoPosoennoismeTextsFR_EN_ES_20260203
NOTES:
  - JSON attendu (prioritaire): { fr:{html:"..."}, en:{html:"..."}, es:{html:"..."} }
  - Supporte aussi (fallback): { texts:{ fr:{html:"..."}, ... } }
  - Le JS détecte la langue (fr/en/es), injecte le HTML correspondant, protège les termes canoniques et synchronise les boutons.
  - Multi-instances OK.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_POSOENNOISME_TEXTS_20260203__) return;
  window.__PO_POSOENNOISME_TEXTS_20260203__ = true;

  var ROOT_SEL = '.po-docwrap[data-po-posoennoisme]';
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_hero_lang";
  var JSON_ASSET_NAME = "po-posoennoisme-texts-fr-en-es-20260203.json";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g,"-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    if (s.indexOf("en") === 0) return "en";
    return "fr";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      return v ? normLang(v) : "";
    }catch(e){ return ""; }
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(e){}
    return l;
  }

  function detectRawLang(){
    try{
      if (typeof window !== "undefined" && window.PO_SITE_LANG) return window.PO_SITE_LANG;
      if (window.GoodyHeroTwinLang && typeof window.GoodyHeroTwinLang.getLang === "function") return window.GoodyHeroTwinLang.getLang();
    }catch(e){}

    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return dl;

    var nav = (typeof navigator !== "undefined") ? navigator : null;
    if (nav && nav.languages && nav.languages.length) return nav.languages[0] || "";
    if (nav && nav.language) return nav.language || "";

    return "fr";
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    return normLang(detectRawLang());
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }
    catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }

  function getJsonURL(){
    var tag = document.getElementById("po-posoennoisme-json-url");
    if (tag){
      var u = "";

      if (tag.getAttribute && tag.getAttribute("data-json-url")){
        u = tag.getAttribute("data-json-url").trim();
        if (u) return u;
      }

      if (tag.textContent){
        u = tag.textContent.trim();
        if (u) return u;
      }
    }
    return "/assets/" + JSON_ASSET_NAME;
  }

  var CACHE = null;
  var CACHE_PROM = null;

  function loadJSON(){
    if (CACHE) return Promise.resolve(CACHE);
    if (CACHE_PROM) return CACHE_PROM;

    var url = getJsonURL();
    CACHE_PROM = fetch(url, { cache: "no-store" })
      .then(function(r){
        if (!r.ok) throw new Error("JSON fetch failed: " + r.status);
        return r.json();
      })
      .then(function(j){ CACHE = j || null; return CACHE; })
      .catch(function(err){ CACHE_PROM = null; throw err; });

    return CACHE_PROM;
  }

  function pickHTML(data, lang){
    try{ if (data && data[lang] && data[lang].html != null) return clampStr(data[lang].html); }catch(e){}
    try{ if (data && data.texts && data.texts[lang] && data.texts[lang].html != null) return clampStr(data.texts[lang].html); }catch(e){}
    try{ if (data && data.fr && data.fr.html != null) return clampStr(data.fr.html); }catch(e){}
    try{ if (data && data.texts && data.texts.fr && data.texts.fr.html != null) return clampStr(data.texts.fr.html); }catch(e){}
    return "";
  }

  function ensureSlot(root){
    var slot = qs(root, '[data-po-slot="content"]');
    if (slot) return slot;
    slot = document.createElement("div");
    slot.setAttribute("data-po-slot","content");
    root.appendChild(slot);
    return slot;
  }

  function escapeRegExp(s){ return clampStr(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

  function normalizeForVariants(s){
    var x = clampStr(s);
    x = x.replace(/[’'`´]/g, "'");
    x = x.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    x = x.replace(/æ/g, "ae").replace(/Æ/g, "AE");
    try{ x = x.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }catch(e){}
    return x;
  }

  function uniqTerms(list){
    var seen = Object.create(null), out = [];
    function add(t){
      t = clampStr(t).trim();
      if (!t) return;
      var variants = [
        t,
        t.replace(/œ/g,"oe").replace(/Œ/g,"OE").replace(/æ/g,"ae").replace(/Æ/g,"AE"),
        t.replace(/[’`´]/g,"'"),
        normalizeForVariants(t)
      ];
      for (var i=0;i<variants.length;i++){
        var v = variants[i];
        if (v && !seen[v]){ seen[v]=true; out.push(v); }
      }
    }
    for (var i=0;i<list.length;i++) add(list[i]);
    out.sort(function(a,b){ return b.length - a.length; });
    return out;
  }

  var _protectTerms = null;

  function buildProtectTerms(){
    if (Array.isArray(window.PO_DOC_POSOENNOISME_PROTECT_TERMS) && window.PO_DOC_POSOENNOISME_PROTECT_TERMS.length){
      return uniqTerms(window.PO_DOC_POSOENNOISME_PROTECT_TERMS);
    }

    var out = [
      "Le Posœnnoïsme", "Posœnnoïsme", "Posœnnoïa", "La Posœnnoïa", "Organon posœnnoïal", "L’Organon posœnnoïal",
      "Katûvýs", "La Katûvýs", "Humanus", "Multiple-pluriel", "Méditations Posœnnoïales", "Accords Posœnnoïaux",
      "Posœnnoïamie", "Posœnnomia", "Posœnnoïal", "Posœnnoïale", "Posœnnoïaux", "Posœnnoïales",
      "Katûpirsia", "RéZonans", "Aliœvolution", "Péroptissimisme", "Addition synchrêtique", "Instantané multiple", "Sujet pluriel",
      "Superposition de perspectives", "Modalités opératives", "Piliers", "Outils", "Engrenages"
    ];

    var src = window.PO_LEXICON;
    if (!Array.isArray(src)){
      if (Array.isArray(window.PO_LEXICON_DATA)) src = window.PO_LEXICON_DATA;
      else if (Array.isArray(window.PO_LEXICON_ENTRIES)) src = window.PO_LEXICON_ENTRIES;
    }

    if (Array.isArray(src)){
      for (var i=0;i<src.length;i++){
        var e = src[i];
        if (!e) continue;
        if (e.terms && e.terms.fr) out.push(e.terms.fr);
        else {
          if (e.term_fr) out.push(e.term_fr);
          if (e.fr) out.push(e.fr);
          if (e.name) out.push(e.name);
          if (e.label) out.push(e.label);
        }
      }
    }
    return uniqTerms(out);
  }

  function getProtectTerms(){
    if (_protectTerms) return _protectTerms;
    _protectTerms = buildProtectTerms();
    return _protectTerms;
  }

  function shouldSkipTextNode(node){
    var p = node && node.parentNode;
    while (p && p.nodeType === 1){
      var tag = (p.tagName || "").toLowerCase();
      if (tag === "script" || tag === "style" || tag === "textarea" || tag === "noscript") return true;
      if (p.getAttribute && p.getAttribute("data-po-lex-protect") === "1") return true;
      p = p.parentNode;
    }
    return false;
  }

  function protectCanonicalTerms(root){
    if (!root || !document.createTreeWalker) return;
    var terms = getProtectTerms();
    if (!terms || !terms.length) return;

    var use = terms.slice(0, 420).map(escapeRegExp).filter(Boolean);
    if (!use.length) return;

    var re;
    try{ re = new RegExp("(" + use.join("|") + ")", "g"); }catch(e){ return; }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        if (!node || !node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (shouldSkipTextNode(node)) return NodeFilter.FILTER_REJECT;
        re.lastIndex = 0;
        return re.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (var n=0;n<nodes.length;n++){
      var text = nodes[n].nodeValue;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0, m;

      while ((m = re.exec(text))){
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement("span");
        span.className = "notranslate";
        span.setAttribute("translate","no");
        span.setAttribute("data-po-lex-protect","1");
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }

      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      try{ nodes[n].parentNode.replaceChild(frag, nodes[n]); }catch(e){}
    }
  }

  function setButtons(root, lang){
    var btns = root.querySelectorAll("[data-po-doc-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var on = b.getAttribute("data-po-doc-lang") === lang;
      b.setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function applyToRoot(root, data, lang){
    var L = normLang(lang || getLang());
    var slot = ensureSlot(root);
    var html = pickHTML(data, L);

    root.setAttribute("translate", "no");
    root.classList.add("notranslate");
    root.setAttribute("lang", L);
    root.setAttribute("data-po-lang", L);

    slot.innerHTML = html || '<p class="po-doc-error">Texte indisponible.</p>';
    protectCanonicalTerms(slot);
    setButtons(root, L);
  }

  function applyAll(data){
    var lang = getLang();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) applyToRoot(roots[i], data, lang);
  }

  function setLang(raw){
    var l = storeLang(raw);
    if (CACHE) applyAll(CACHE);
    notifyLocaleChanged();
    return l;
  }

  function hookButtons(){
    document.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest("[data-po-doc-lang]") : null;
      if (!btn) return;
      ev.preventDefault();
      setLang(btn.getAttribute("data-po-doc-lang") || "fr");
    }, false);
  }

  function init(){
    hookButtons();
    loadJSON()
      .then(function(data){
        applyAll(data);

        try{
          window.addEventListener("goody:hero:lang", function(ev){
            var l = ev && ev.detail ? ev.detail.lang : getLang();
            setLang(l);
          }, false);
        }catch(e){}

        try{
          var mo = new MutationObserver(function(muts){
            for (var i=0;i<muts.length;i++){
              if (muts[i].type === "attributes" && muts[i].attributeName === "lang"){
                if (CACHE) applyAll(CACHE);
                notifyLocaleChanged();
                break;
              }
            }
          });
          if (document && document.documentElement) mo.observe(document.documentElement, { attributes:true });
        }catch(e){}
      })
      .catch(function(err){
        var roots = document.querySelectorAll(ROOT_SEL);
        for (var i=0;i<roots.length;i++){
          var slot = ensureSlot(roots[i]);
          slot.innerHTML = '<p class="po-doc-error">Le texte d’introduction n’a pas pu être chargé.</p>';
        }
        try{ console.warn("[Posœnnoïsme] JSON not loaded:", err); }catch(e){}
      });
  }

  window.PoPosoennoismeTextsFR_EN_ES_20260203 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: setLang,
    reload: function(){
      CACHE = null;
      CACHE_PROM = null;
      return loadJSON().then(function(d){ applyAll(d); return d; });
    },
    protectCanonicalTerms: protectCanonicalTerms
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { passive:true });
  else init();
})();